export class Url {
    // Base URL → toujours relative
    static URL_BD = "/api";

    static getUrlApi() {
        return this.URL_BD + "/app";
    }

    static getUrlAdmin() {
        return this.URL_BD + "/admin";
    }

    static getUrlAuth() {
        return this.URL_BD + "/auth";
    }
}
